import NavIcon from "../components/nav-icon"
import BannerRight from "../components/banner-right"
import WrapperPost from "../components/blog/wrapper-post"

const Post = ()=> {
    return (
        <>
        <NavIcon/>
        <BannerRight/>
        <WrapperPost/>
        </>
    )
}
export default Post